/**
 * Labstep
 *
 * @module components/OrderRequest/Action/UpdateUrgent
 * @desc Action to update is_urgent field
 */

import { EntityActionUpdateCheckbox } from 'labstep-web/components/Entity/Action/Update/Checkbox';
import type React from 'react';
import type { OrderRequestActionUpdateUrgentBulkProps } from './types';

export const OrderRequestActionUpdateUrgentBulk: React.FC<
  OrderRequestActionUpdateUrgentBulkProps
> = ({ orderRequest }) => (
  <EntityActionUpdateCheckbox
    entity={orderRequest}
    field={'is_urgent' as const}
    optimistic
  />
);
